const logError = () => {
  // log error to where ever - sentry, newrelic
};

export default logError;
